import { setTrailingSlash } from '../../server/helpers/setTrailingSlash.js';

/**
 * Builds a product page URL from an option's pid and sku.
 * Replaces the previous flow of consuming a pre-built `url` field from the
 * EMS payload; the new EMS API (window.emsData.emsDetails) omits `url` and
 * provides `pid` and `sku` instead.
 * @param {object} option    - An option object containing `pid` and `sku`.
 * @param {object} config    - Optional URL construction settings.
 * @param {string} config.locale  - Current locale (e.g. `en-US`).
 * @param {string} config.origin  - URL origin (defaults to `https://www.garmin.com`).
 * @returns {string} Product page URL, or empty string when pid/sku missing.
 * @example
 * buildProductPageUrl({ pid: 950277, sku: '010-02839-00' }, {
 *   locale: 'en-US',
 *   origin: 'https://www.garmin.com',
 * }) => 'https://www.garmin.com/en-US/p/950277/pn/010-02839-00/'
 */
export const buildProductPageUrl = (option, { locale = '', origin = 'https://www.garmin.com' } = {}) => {
  const pid = option?.pid;
  const sku = option?.sku;
  if (!pid || !sku) return '';

  const localePath = locale ? `/${locale}` : '';
  return setTrailingSlash(`${origin}${localePath}/p/${pid}/pn/${sku}`);
};
